import { h, Component } from "preact";

import { Alert, Snackbar } from "@mui/material";

export class BkSnack extends Component {
	state = { o: false, m: "", s: "success" };

	handleChangeState = (st) => {
		this.setState({ ...this.state, ...st });
	};
	handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		this.setState({ o: false });
	};
	render() {
		return (
			<Snackbar
				open={this.state.o}
				autoHideDuration={3000}
				onClose={this.handleClose}
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				key={"tc"}
			>
				<Alert onClose={this.handleClose} severity={this.state.s}>
					{this.state.m}
				</Alert>
			</Snackbar>
		);
	}
}